import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "p-fluid pt-3" }
const _hoisted_2 = { class: "field col-12" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "p-float-label" }
const _hoisted_5 = {
  key: 0,
  class: "p-error"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "recipeTitle",
  class: "text--mini text--darker"
}, "Title", -1)
const _hoisted_8 = { id: "recipeTitle" }
const _hoisted_9 = { class: "field col-12" }
const _hoisted_10 = {
  key: 0,
  class: "p-float-label"
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  for: "imageLink",
  class: "text--mini text--darker"
}, "Image", -1)
const _hoisted_13 = { class: "field col-12" }
const _hoisted_14 = {
  key: 0,
  class: "p-float-label"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", {
  for: "recipeDescription",
  class: "text--mini text--darker pl-2"
}, " Description ", -1)
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  key: 0,
  class: "field col-12"
}
const _hoisted_18 = { class: "p-float-label" }
const _hoisted_19 = { class: "field col-12" }
const _hoisted_20 = {
  key: 0,
  class: "p-float-label"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { for: "tags" }, "Tags", -1)
const _hoisted_22 = { key: 1 }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", {
  for: "recipeTags",
  class: "text--mini text--darker"
}, "Tags", -1)
const _hoisted_24 = {
  id: "recipeTags",
  class: "mt-2"
}
const _hoisted_25 = { key: 0 }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "ml-1" }, "Edit", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "ml-1" }, "Delete", -1)
const _hoisted_28 = { key: 1 }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "ml-1" }, "Save", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "ml-1" }, "Cancel", -1)

import { withDefaults, computed, Ref, ref as ref, ComputedRef } from "vue"
import { required } from "@vuelidate/validators"
import useVuelidate from "@vuelidate/core"
import { useToast } from "primevue/usetoast"
import Recipe from "@/models/recipe/Recipe"
import RecipeController from "@/controllers/recipes/RecipeController"
import { getAuth, onAuthStateChanged } from "@firebase/auth"
import firebaseApp from "@/utilities/firebase/firebase"
import RecipeTag from "@/models/recipe/RecipeTag"
import RecipeTagController from "@/controllers/recipes/RecipeTagController"
import { AutoCompleteCompleteEvent, AutoCompleteItemSelectEvent } from "primevue/autocomplete"
import Image from "@/components/form/Image.vue"
import QuillEditor from "@/components/form/QuillEditor.vue"
import { useConfirm } from "primevue/useconfirm"


/* ------------------- Props ----------------- */

interface propsInterface {
	isOpen?: boolean
	recipeId: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'RecipeDetailsModal',
  props: {
    isOpen: { type: Boolean, default: false },
    recipeId: null
  },
  emits: ["change-open-state", "list-changed"],
  setup(__props: any, { emit }: { emit: ({
	(event: "change-open-state", isOpen: boolean): void,
	(event: "list-changed", recipe: Recipe): string,
}), expose: any, slots: any, attrs: any }) {

const props = __props as { isOpen: boolean, recipeId: string };





/* ------------------- Properties ----------------- */

const toast = useToast()
const confirm = useConfirm()
const recipeController = new RecipeController()
const recipeTagController = new RecipeTagController()

const isVisible = computed({
	get() {
		return props.isOpen
	},
	set(value: boolean) {
		emit("change-open-state", value)
	}
})
const isNew: ComputedRef<boolean> = computed(() => recipeDetails.value.id.length === 0)
const canEdit: ComputedRef<boolean> = computed(() => isNew.value || currentUserId.value === recipeDetails.value.insertedByUID)
		
const currentUserId: Ref<string> = ref("")
const isEditing: Ref<boolean> = ref(false)
const recipeDetailsOriginal: Ref<Recipe> = ref(new Recipe())
const recipeDetails: Ref<Recipe> = ref(new Recipe())
const recipeTags: Ref<RecipeTag[]> = ref([])
const filteredRecipeTags: Ref<RecipeTag[]> = ref([])
const defaultImageUrl: Ref<string> = ref("")

/* ------------------- Validation ----------------- */

const rules = {
	title: { required },
	//description: {},
	recipeUrl: {},
	imageLink: {},
}
const validation = useVuelidate(rules, recipeDetails)
const hasBeenSubmitted = ref(false)

/* ------------------- Methods ----------------- */

function changeOpenState(isOpen: boolean) {
	isVisible.value = isOpen
}

async function onRecipeModalOpen() {
	await loadRecipeModal()

	if (isNew.value) {
		beginEdit()
	}
}

function onRecipeModalClosed() {
	resetModalState()
}

async function loadRecipeModal() {
	recipeTags.value = await getRecipeTags()
	recipeDetails.value = await getRecipe()
	recipeDetailsOriginal.value = recipeDetails.value
	defaultImageUrl.value = recipeController.getDefaultImageUrl()

	const auth = getAuth(firebaseApp)

	onAuthStateChanged(auth, (user) => {
		// User is signed in
		if (!user) {
			return
		}

		currentUserId.value = user.uid
	})
}

function beginEdit() {
	isEditing.value = true
}

function updateDescription(newDescription:string) {
	recipeDetails.value.description = newDescription;
}

function cancelEdit() {
	resetModalState()

	if (isNew.value) {
		changeOpenState(false)
	}
}

function resetModalState() {
	recipeDetails.value = { ...recipeDetailsOriginal.value }
	isEditing.value = false
	hasBeenSubmitted.value = false
}

async function getRecipe(): Promise<Recipe> {

	if (props.recipeId.length === 0) {
		return new Recipe()
	}

	return recipeController.get(props.recipeId)
}

async function getRecipeTags(): Promise<RecipeTag[]> {
	return recipeTagController.getAll()
}

async function saveRecipe() {

	hasBeenSubmitted.value = true
	validation.value.$validate()

	if (validation.value.$error) {
		return
	}

	const isNew: boolean = recipeDetails.value.id.length === 0
	const isSaved = isNew ? await addRecipe(recipeDetails.value) : await updateRecipe(recipeDetails.value)

	if (isSaved) {
		emit("list-changed", recipeDetails.value)
		changeOpenState(false)
		return resetModalState()
	}
}

async function addRecipe(recipe: Recipe) {
	const currentUser = getAuth(firebaseApp).currentUser
	recipe.insertedByUID = currentUser?.uid ?? ""
	recipe.insertedByEmail = currentUser?.email ?? ""

	return recipeController.add(recipe)
		.then(() => {
			toast.add({ severity: "success", summary: "Success", detail: "Successfully added recipe", life: 5000 })
			return true
		})
		.catch(error => {
			console.error(`code: ${error.code}\n message: ${error.message}\n stack: ${error.stack}\n`)
			toast.add({ severity: "error", summary: "Error adding recipe", detail: `${error}` })
			return false
		})
}

async function updateRecipe(recipe: Recipe) {
	return recipeController.update(recipe)
		.then(() => {
			toast.add({ severity: "success", summary: "Success", detail: "Successfully updated recipe", life: 5000 })
			return true
		})
		.catch(error => {
			console.error(`code: ${error.code}\n message: ${error.message}\n stack: ${error.stack}\n`)
			toast.add({ severity: "error", summary: "Error updating recipe", detail: `${error}` })
			return false
		})
}

function deleteRecipe(event: Event, recipe: Recipe) {
	confirm.require({
		target: event.currentTarget as HTMLElement,
		message: `Are you sure you want to delete "${recipe.title}"?`,
		icon: "fas fa-exclamation-triangle",
		acceptClass: "p-button-danger",
		accept: async () => {
			await recipeController.delete(recipe.id)
			toast.add({ severity: "success", summary: "Success", detail: `Successfully deleted "${recipe.title}"`, life: 3000 })

			emit("list-changed", recipeDetails.value)
			changeOpenState(false)
			return resetModalState()
		},
		reject: () => {
			return
		}
	})
}

async function addNewRecipeTag(event: AutoCompleteItemSelectEvent): Promise<void> {

	let recipeTag = event?.value as RecipeTag
	const isNewRecipeTag = recipeTag?.id?.length === 0
	if (!isNewRecipeTag) {
		return
	}

	const startIndex = recipeTag.title.indexOf('"') + 1
	const endIndex = recipeTag.title.lastIndexOf('"')
	const newRecipeTagTitle = recipeTag.title.substring(startIndex, endIndex)
	recipeTag.title = newRecipeTagTitle

	const isValidTag = recipeTag.title?.length > 2;
	if (!isValidTag) {
		setTimeout(() => {
			recipeDetails.value.tags = recipeDetails.value.tags.filter(tag => tag.title !== newRecipeTagTitle)
		}, 0);
		return toast.add({ severity: "error", summary: "Error adding recipe tag", detail: `The tag must have more than 2 characters and they must be valid`, life: 3000 })
	}

	try {
		filteredRecipeTags.value = [...recipeTags.value]

		await recipeTagController.add(recipeTag)
		recipeTags.value = await getRecipeTags()

		const newSavedTag = recipeTags.value.find(tag => tag.title.toLowerCase() === newRecipeTagTitle.toLowerCase())
		if (newSavedTag == null) {
			throw new Error("The tag does not exist in the database")
		}

		toast.add({ severity: "success", summary: "Success", detail: `Successfully created new tag: "${newRecipeTagTitle}"`, life: 3000 })
	} catch (error) {
		toast.add({ severity: "error", summary: "Error adding recipe tag", detail: `${error}` })
	}

}

function searchRecipeTags(event: AutoCompleteCompleteEvent) {
	setTimeout(() => {
		const searchInput = event?.query?.trim().toLowerCase()
		if (searchInput?.length === 0) {
			filteredRecipeTags.value = [...recipeTags.value]
			return
		}

		const hasRecipeTagTemplate = filteredRecipeTags.value.some(tag => tag?.id?.length === 0)
		if (hasRecipeTagTemplate) {
			filteredRecipeTags.value.pop()
		}

		filteredRecipeTags.value = recipeTags.value.filter((tag) => {
			const hasSearchInput = tag.title.toLowerCase().includes(searchInput)
			const isAlreadyAdded = recipeDetails.value.tags.some(existingTag => existingTag.title === tag.title)

			return hasSearchInput && !isAlreadyAdded
		})

		const isSearchInputExactMatch = filteredRecipeTags.value.some(filteredTag => filteredTag.title.toLowerCase() === searchInput)
		if (isSearchInputExactMatch) {
			return
		}
		const newRecipeTagTemplate = new RecipeTag({title:` + Add new recipe tag: "${searchInput}"`})
		filteredRecipeTags.value.push(newRecipeTagTemplate)
	}, 100)
}

/* ------------------- Lifecycle ----------------- */
/* https://lifesaver.codes/answer/unmount-modal-on-close
// Check this if decide to move from changing state to mounted/unmounted
onMounted(async () => {

});

onUnmounted(() => {
	isEditing.value = false
})
	*/

return (_ctx: any,_cache: any) => {
  const _component_p_input_text = _resolveComponent("p-input-text")!
  const _component_p_auto_complete = _resolveComponent("p-auto-complete")!
  const _component_p_chip = _resolveComponent("p-chip")!
  const _component_fa = _resolveComponent("fa")!
  const _component_p_button = _resolveComponent("p-button")!
  const _component_p_dialog = _resolveComponent("p-dialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_p_dialog, {
    header: "Recipe Details",
    visible: __props.isOpen,
    onShow: onRecipeModalOpen,
    onHide: onRecipeModalClosed,
    "onUpdate:visible": changeOpenState,
    position: "center",
    displayPosition: true,
    modal: true,
    dismissableMask: true,
    draggable: false,
    closable: true,
    "auto-z-index": true,
    "base-z-index": 100,
    breakpoints: { '1080px': '75vw', '640px': '100vw' },
    class: "container-modal"
  }, _createSlots({
    default: _withCtx(() => [
      _createElementVNode("article", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (isEditing.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_p_input_text, {
                    id: "recipeTitle",
                    modelValue: _unref(validation).title.$model,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(validation).title.$model) = $event)),
                    type: "text",
                    autofocus: props.recipeId == '',
                    class: _normalizeClass([{ 'p-invalid': _unref(validation).title.$invalid && hasBeenSubmitted.value }, "w-full"])
                  }, null, 8, ["modelValue", "autofocus", "class"]),
                  _createElementVNode("label", {
                    for: "recipeTitle",
                    class: _normalizeClass({ 'p-error': _unref(validation).title.$invalid && hasBeenSubmitted.value })
                  }, "Title", 2)
                ]),
                (_unref(validation).title.$invalid && hasBeenSubmitted.value)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_5, _toDisplayString(_unref(validation).title.required.$message.replace('Value', 'Title')), 1))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(validation).title.$model), 1)
              ]))
        ]),
        _createElementVNode("div", _hoisted_9, [
          (isEditing.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_p_input_text, {
                  id: "imageLink",
                  modelValue: _unref(validation).imageLink.$model,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(validation).imageLink.$model) = $event)),
                  type: "text",
                  class: _normalizeClass([{ 'p-invalid': _unref(validation).imageLink.$invalid && hasBeenSubmitted.value }, "w-full"])
                }, null, 8, ["modelValue", "class"]),
                _createElementVNode("label", {
                  for: "imageLink",
                  class: _normalizeClass({ 'p-error': _unref(validation).imageLink.$invalid && hasBeenSubmitted.value })
                }, "Image url", 2)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _hoisted_12,
                _createVNode(Image, {
                  id: "imageLink",
                  url: recipeDetails.value.imageLink,
                  "default-url": defaultImageUrl.value,
                  alt: "Recipe image",
                  size: "md",
                  class: "pt-1"
                }, null, 8, ["url", "default-url"])
              ]))
        ]),
        _createElementVNode("div", _hoisted_13, [
          (isEditing.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _hoisted_15,
                _createVNode(QuillEditor, {
                  id: "recipeDescription",
                  "prop-model": recipeDetails.value.description,
                  "placeholder-text": "Description",
                  onChanged: updateDescription,
                  class: "pt-1"
                }, null, 8, ["prop-model"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createVNode(QuillEditor, {
                  "prop-model": recipeDetails.value.description,
                  readonly: true,
                  "placeholder-text": "Description"
                }, null, 8, ["prop-model"])
              ]))
        ]),
        (isEditing.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_p_input_text, {
                  id: "recipeUrl",
                  modelValue: _unref(validation).recipeUrl.$model,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(validation).recipeUrl.$model) = $event)),
                  type: "text",
                  class: _normalizeClass([{ 'p-invalid': _unref(validation).recipeUrl.$invalid && hasBeenSubmitted.value }, "w-full"])
                }, null, 8, ["modelValue", "class"]),
                _createElementVNode("label", {
                  for: "recipeUrl",
                  class: _normalizeClass({ 'p-error': _unref(validation).recipeUrl.$invalid && hasBeenSubmitted.value })
                }, "Recipe url", 2)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_19, [
          (isEditing.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createVNode(_component_p_auto_complete, {
                  id: "tags",
                  inputId: "autoCompleteInputId",
                  modelValue: recipeDetails.value.tags,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((recipeDetails.value.tags) = $event)),
                  suggestions: filteredRecipeTags.value,
                  optionLabel: "title",
                  multiple: "",
                  dropdown: "",
                  forceSelection: true,
                  onItemSelect: addNewRecipeTag,
                  onComplete: _cache[4] || (_cache[4] = ($event: any) => (searchRecipeTags($event)))
                }, {
                  chip: _withCtx(({ value }) => [
                    _withDirectives((_openBlock(), _createElementBlock("div", null, [
                      _createTextVNode(_toDisplayString(value.title), 1)
                    ])), [
                      [
                        _directive_tooltip,
                        { value: value.description, disabled: value.description.length === 0 },
                        void 0,
                        { bottom: true }
                      ]
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "suggestions"]),
                _hoisted_21
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("div", _hoisted_24, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recipeDetails.value.tags, (tag) => {
                    return (_openBlock(), _createBlock(_component_p_chip, {
                      label: tag.title,
                      key: tag.id,
                      class: "mr-1 mb-1"
                    }, null, 8, ["label"]))
                  }), 128))
                ])
              ]))
        ])
      ])
    ]),
    _: 2
  }, [
    (_unref(canEdit))
      ? {
          name: "footer",
          fn: _withCtx(() => [
            (!isEditing.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _createVNode(_component_p_button, {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (beginEdit())),
                    class: "p-button-rounded p-button-primary m-1"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_fa, { icon: ['fas', 'pencil-alt'] }),
                      _hoisted_26
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_p_button, {
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (deleteRecipe($event, recipeDetails.value))),
                    class: "p-button-rounded p-button-danger m-1"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_fa, { icon: ['fas', 'trash'] }),
                      _hoisted_27
                    ]),
                    _: 1
                  })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _createVNode(_component_p_button, {
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (saveRecipe())),
                    class: "p-button-success m-1"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_fa, { icon: ['fas', 'check'] }),
                      _hoisted_29
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_p_button, {
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (cancelEdit())),
                    class: "p-button-rounded p-button-text m-1"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_fa, { icon: ['fas', 'times'] }),
                      _hoisted_30
                    ]),
                    _: 1
                  })
                ]))
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["visible"]))
}
}

})